// src/event-bus.js
import mitt from 'mitt';
const EventBus = mitt();
export default EventBus;
